import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FloorPlanSVG = function FloorPlanSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4 30h3a1 1 0 000-2H4V15h10v2a1 1 0 002 0V8a1 1 0 00-2 0v5H4V4h24v9h-7a1 1 0 000 2h7v13H16v-5h3a1 1 0 000-2h-4a1 1 0 00-1 1v7a1 1 0 001 1h13a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v24a2 2 0 002 2z"
  }));
};
FloorPlanSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FloorPlanSVG);